import { createRef, useContext, useEffect, useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Divider,
  List,
  makeStyles,
  Paper,
  TextField,
  Typography,
} from '@material-ui/core';
import 'moment-timezone';
import SendIcon from '@material-ui/icons/Send';

import { Comment } from './comment';
import { CommentContext } from '../../../../services/meeting-details/meeting-details-comment.context';

const useStyles = makeStyles((theme) => {
  return {
    avatar: {
      width: theme.spacing(3),
      height: theme.spacing(3),
      marginRight: 16,
    },
    cardHeader: {
      backgroundColor: '#f7f7f7',
    },
    comment: {
      margin: '1rem',
    },
    addComment: {
      margin: '1rem auto',
    },
    icon: {
      marginRight: 16,
    },
    wrapper: {
      width: 'max-content',
      margin: '24px 0',
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
    },
    buttonProgress: {
      color: '#000',
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12,
    },
  };
});

export const CommentContainer = ({ m_id }) => {
  const classes = useStyles();
  const [comment, setComment] = useState('');
  const { comments, addComment, isCommentLoading, getMeetingComments } =
    useContext(CommentContext);

  const inputRef = createRef();

  useEffect(() => {
    if (inputRef) {
      inputRef.current.dir = 'auto';
    }

    getMeetingComments(m_id);
  }, []);

  //======================================================================

  return (
    <>
      <Box p={3}>
        <Typography variant='h6'>Comments</Typography>
      </Box>

      <Box p={2} alignContent='center' dir='auto'>
        <TextField
          inputRef={inputRef}
          label='Comment'
          fullWidth
          value={comment}
          multiline
          onChange={(e) => setComment(e.target.value)}
        />
        <Box className={classes.wrapper}>
          <Button
            size='small'
            className={classes.addComment}
            variant='contained'
            color='primary'
            endIcon={<SendIcon />}
            type='submit'
            id='send-comment'
            disabled={isCommentLoading}
            onClick={(e) => addComment(e, m_id, comment, setComment)}
          >
            Send
          </Button>
          {isCommentLoading && (
            <CircularProgress size={24} className={classes.buttonProgress} />
          )}
        </Box>
        {/* {error && (
            <Typography variant='caption' color='error'>
              {error}
            </Typography>
          )} */}
      </Box>

      <Paper elevation={4} style={{ maxHeight: 400, overflow: 'auto' }}>
        <Container>
          <Divider />

          {comments &&
            comments.length > 0 &&
            comments.map((comment, index) => (
              <Paper key={`${index}-${comment.comment}`}>
                <List>
                  <Comment comment={comment} m_id={m_id} />
                </List>
              </Paper>
            ))}
        </Container>
      </Paper>
    </>
  );
};
